/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dr_Proof_Cmd_CaptionInputs */

const en_dr_proof_cmd_caption = /** @type {(inputs: Dr_Proof_Cmd_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evidence uploaded on the linked task flips the hypothesis from "untested" to "supported" or "refuted" automatically.`)
};

const id_dr_proof_cmd_caption = /** @type {(inputs: Dr_Proof_Cmd_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bukti yang diunggah pada task terkait otomatis mengubah status hipotesis dari "belum diuji" menjadi "terdukung" atau "terbantah".`)
};

/**
* | output |
* | --- |
* | "Evidence uploaded on the linked task flips the hypothesis from \"untested\" to \"supported\" or \"refuted\" automatically." |
*
* @param {Dr_Proof_Cmd_CaptionInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const dr_proof_cmd_caption = /** @type {((inputs?: Dr_Proof_Cmd_CaptionInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dr_Proof_Cmd_CaptionInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_dr_proof_cmd_caption(inputs)
	return en_dr_proof_cmd_caption(inputs)
});